import { render, staticRenderFns } from "./IndentedSpan.vue?vue&type=template&id=f0e3422c&"
import script from "./IndentedSpan.vue?vue&type=script&lang=js&"
export * from "./IndentedSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports